export default "__VITE_ASSET__CU8Ewd6d__"